import GetDeviceID from '@security/data/usecases/GetDeviceID';
import DeviceInfo from '@security/infra/protocols/device/DeviceInfo';

export default new GetDeviceID(new DeviceInfo());
